import type { ReactNode } from "react";

type SectionHeadingProps = {
  kicker?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  light?: boolean;
};

export default function SectionHeading({
  kicker,
  title,
  desc,
  align = "center",
  light = false,
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={`${isCenter ? "text-center" : "text-left"}`}>
      {kicker && (
        <span
          className={`inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] ${
            light ? "text-accent-300" : "text-accent-600"
          }`}
        >
          <span className={`h-px w-6 ${light ? "bg-accent-300" : "bg-accent-500"}`} />
          {kicker}
          <span className={`h-px w-6 ${light ? "bg-accent-300" : "bg-accent-500"}`} />
        </span>
      )}
      <h2
        className={`mt-3 font-heading text-2xl font-bold md:text-3xl ${
          light ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p
          className={`mx-auto mt-3 max-w-2xl text-sm leading-relaxed md:text-base ${
            isCenter ? "mx-auto" : ""
          } ${light ? "text-background-200" : "text-foreground-600"}`}
        >
          {desc}
        </p>
      )}
    </div>
  );
}

export function Breadcrumb({ items }: { items: { label: string; to?: string }[] }) {
  return (
    <nav
      aria-label="面包屑"
      className="mb-6 flex flex-wrap items-center gap-1.5 text-xs text-foreground-500"
    >
      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        return (
          <span key={item.label} className="flex items-center gap-1.5">
            {item.to && !isLast ? (
              <a href={item.to} className="transition-colors hover:text-primary-600">
                {item.label}
              </a>
            ) : (
              <span className={isLast ? "font-medium text-foreground-800" : "text-foreground-400"}>
                {item.label}
              </span>
            )}
            {!isLast && <i className="ri-arrow-right-s-line text-foreground-300" />}
          </span>
        );
      })}
    </nav>
  );
}